import type { FC } from 'react';
import { Digits } from '@/shared/Digits';
import { cn } from '@/shared/react';
import { useConvertPreview } from './api';

export const PriceSummaryFooter: FC<{
  fromCoin: string;
  toCoin: string;
}> = ({ fromCoin, toCoin }) => {
  const amountField =
    (fromCoin === 'IQD' && toCoin === 'USDT') ||
    (toCoin !== 'IQD' && toCoin !== 'USDT')
      ? 'to_amount'
      : 'from_amount';

  const convertPreview = useConvertPreview({
    [amountField]: '1',
    from_coin: fromCoin,
    to_coin: toCoin,
  });

  return (
    <div className={cn('p-3 size-full', convertPreview.isLoading && 'shimmer')}>
      <div
        className={cn(
          'inline-flex gap-1 items-center justify-start',
          amountField === 'to_amount' && 'flex-row-reverse',
        )}
      >
        <Digits
          value={
            amountField === 'from_amount' ? '1' : convertPreview.data?.price
          }
          coin={fromCoin}
        />
        <span className="text-content-tertiary mx-px">=</span>
        <Digits
          value={
            amountField === 'from_amount' ? convertPreview.data?.price : '1'
          }
          coin={toCoin}
        />
      </div>
    </div>
  );
};
